const appid = Symbol('appid');
const middle = Symbol('middle');
const timeout = Symbol('timeout');
class AcstaticDunAntiCheating {
  constructor() {
    this[middle] = this.acstaticDunSSRConfig?.acstaticDun?.middle ?? [
      //  下单
      'shop/order/v2/save',
      //  支付
      'shop/pay/submit',
      //  发送登录短信验证码
      'operator/login/sendLoginSms.do',
      //  短信登录
      'operator/login/smsLogin.do',
      //  发送第三方的登录短信验证码
      'operator/register/sendRegisterSms.do',
      //  注册并绑定接口
      'operator/register/bind.do',
      //  激活并绑定接口
      'operator/register/active/bind.do',
      //  授权登陆
      'operator/login/authLogin.do',
      //  微信绑定手机号
      'operator/register/bindLoginName.do',
      //  H5 浏览器助力进入，绑定或注册接口
      'operator/register/wechatRegisterAndBind.do'
    ];
    this[appid] = this.acstaticDunSSRConfig?.acstaticDun?.appid ?? 'YD00481894759076';
    this[timeout] = this.acstaticDunSSRConfig?.acstaticDun?.timeout ?? 10000;

    this.currentToken = {
      value: ''
    };
  }
  get neg() {
    return window.createNEGuardian({ appId: this[appid], timeout: this[timeout] });
  }
  getCurrentTime(timeLength = 23) {
    return (date => new Date(date - date.getTimezoneOffset() * 6e4).toJSON().substr(0, timeLength).replace('T', ' '))(new Date()).replace(/[\-\s\:\.Z]/g, '')
  }
  /**
   * 金盾反作弊过滤器
   */
  async checkAcstaticDunAntiCheating(url) {
    let isContinue = true;
    const isMiddle = this[middle].filter(e => url.indexOf(e) !== -1).length;
    if (!isMiddle) {
      isContinue = false;
    }
    //  js 未加载
    if (isContinue && !(window?.createNEGuardian)) {
      try {
        await this.loadScript();
      } catch(error) {
        isContinue = false;
      }
    }
    const currentToken = await this.getToken();
    if (!(currentToken && isContinue)) {
      return { isAntiCheating: false, token: '' };
    }
    return { isAntiCheating: true, token: currentToken };
  }
  async getToken() {
    try {
      const res = await this.neg.getToken();
      const code = res?.code - 0;
      if (!!(code === 200 || code === 201) && !!(res?.token)) {
        this.currentToken.value = res.token;
        return res.token;
      }
    } catch(error) {}
    return '';
  }
  /**
   * 加载反作弊 script
   */
  loadScript() {
    return new Promise((resolve, reject) => {
      try {
        this.acstaticDunScript && this.acstaticDunScript.remove();
        this.acstaticDunScript = undefined;
        this.acstaticDunScript = document.createElement('script');
        this.acstaticDunScript.src = '/mobile-h5/public/libs/acstatic-dun/YiDunProtector-Web-1.0.2.js';
        this.acstaticDunScript.onload = resolve;
        this.acstaticDunScript.onerror = reject;
        document.head.appendChild(this.acstaticDunScript);
      } catch(err) {
        reject(err);
      }
    })
  }
}
export default AcstaticDunAntiCheating
